module.exports = "new-module";


/*****************
 ** WEBPACK FOOTER
 ** ./resolving/browser-field/~/new-module/index.js
 ** module id = 14
 ** module chunks = 0
 **/